import React from "react";
import { Typography, Box } from "@mui/material";
import { BCPCircle1, BCPCircle2 } from "../../../components/icons/bcp/BCPIcons";

const PRIORITY_COLORS = ["#8b5cf6", "#3b82f6"];
const PRIORITY_ICONS = [BCPCircle1, BCPCircle2];

export default function AttackDefendStats({ rows, label, theme }) {
  if (!rows) return null;

  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
        borderRadius: 1,
        p: 2.5,
        boxShadow: isDark
          ? "0 2px 8px rgba(0,0,0,0.3)"
          : "0 2px 8px rgba(0,0,0,0.1)",
        height: "100%"
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2.5,
          color: theme.palette.text.secondary,
          textAlign: "center"
        }}
      >
        {label || "Attacker / Defender"}
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        {rows?.map((item, i) => {
          const color = PRIORITY_COLORS[i % PRIORITY_COLORS.length];
          const PriorityIcon = PRIORITY_ICONS[i % PRIORITY_ICONS.length];
          return (
            <Box
              key={i}
              sx={{
                flex: 1,
                textAlign: "center",
                p: 2,
                borderRadius: 1,
                border: `1px solid ${color}33`,
                backgroundColor: isDark ? `${color}12` : `${color}0a`
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.text.primary,
                  fontSize: "0.7rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.12em",
                  fontWeight: 600,
                  mb: 1.25
                }}
              >
                {item.label}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 1.25
                }}
              >
                <PriorityIcon size="lg" style={{ color }} />
              </Box>

              <Typography
                sx={{
                  color,
                  fontWeight: 700,
                  fontSize: "2.25rem",
                  lineHeight: 1,
                  mb: 0.5,
                  fontVariantNumeric: "tabular-nums"
                }}
              >
                {item.winRate}%
              </Typography>

              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: "0.65rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  fontWeight: 600,
                  mb: 1.75
                }}
              >
                Win Rate
              </Typography>

              <Box
                sx={{
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: isDark
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.08)",
                  overflow: "hidden",
                  mb: 1.75
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${item.winRate}%`,
                    borderRadius: 3,
                    background: `linear-gradient(90deg, ${color}55, ${color})`
                  }}
                />
              </Box>

              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: "0.8rem",
                  fontVariantNumeric: "tabular-nums"
                }}
              >
                {item.games.toLocaleString()}
                <Box
                  component="span"
                  sx={{
                    fontSize: "0.65rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    fontWeight: 600,
                    ml: 0.5
                  }}
                >
                  Games
                </Box>
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
